// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesItemInfoRow-module__container--chVEz{display:flex;font-size:11px}.ArticlesItemInfoRow-module__text--NFLRK{width:100px;flex-shrink:0;color:#7b7f83}.ArticlesItemInfoRow-module__content--r_ntr{flex-grow:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticlesItemInfoRow-module__container--chVEz`,
	"text": `ArticlesItemInfoRow-module__text--NFLRK`,
	"content": `ArticlesItemInfoRow-module__content--r_ntr`
};
export default ___CSS_LOADER_EXPORT___;
